var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-delivery_country-message"},[_c('div',{staticClass:"order-delivery_country-message-icon"},[_vm._v("!")]),_vm._v(" "),_c('div',{staticClass:"order-delivery_country-message-text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-672877f3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-svg-inline-loader/dist/index.min.js!./src/components/Order/Delivery/CountryMessage.vue
// module id = a4LU
// module chunks = 1